import React, { Component } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { BadgeCheck, Mail, Pencil, Phone } from "lucide-react";
import { getPreferences } from "../services/StudentPreferenceService";

class ProfileCard extends Component {
  constructor(props) {
    super(props);
    const phoneNo = Cookies.get("phoneNo") || "";
    this.state = {
      username: Cookies.get("username") || "",
      email: Cookies.get("email") || "",
      // Google sign-ins get a "google-<id>" placeholder, not a real phone — don't show it as one.
      phone: phoneNo.startsWith("google-") ? "" : phoneNo,
      location: Cookies.get("location") || "",
      verified: Cookies.get("verified") || false,
      preferences: null,
    };
  }

  componentDidMount() {
    getPreferences()
      .then((res) => this.setState({ preferences: res.data }))
      .catch(() => {});
  }

  render() {
    const { username, email, phone, location, verified, preferences } = this.state;
    const displayValue = (value) => (value && String(value).trim() ? value : "—");

    const prefs = [
      ["Stream", preferences?.stream],
      ["Programme", preferences?.preferredCourse],
      ["Preferred Location", preferences?.preferredLocation],
      ["Exams Interested In", preferences?.examInterested],
      ["Admission Year", preferences?.admissionYear],
      ["Education Mode", preferences?.educationMode],
    ];

    return (
      <section className="my-4 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div className="bg-gradient-to-r from-brand-600 to-brand-700 px-4 py-5 sm:px-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-4 min-w-0">
              <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-white/15 text-xl font-bold text-white ring-2 ring-white/30">
                {username ? username.charAt(0).toUpperCase() : "?"}
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="truncate text-lg font-bold text-white">{username || "—"}</span>
                  {verified && (
                    <span className="inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-xs font-semibold text-white">
                      <BadgeCheck className="h-3.5 w-3.5" />
                      Verified
                    </span>
                  )}
                </div>
                {location && <div className="text-sm text-brand-100">{location}</div>}
                <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-brand-50">
                  {email && (
                    <span className="inline-flex items-center gap-1.5">
                      <Mail className="h-3.5 w-3.5" />
                      {email}
                    </span>
                  )}
                  {phone && (
                    <span className="inline-flex items-center gap-1.5">
                      <Phone className="h-3.5 w-3.5" />
                      {phone}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <Link
              to="/userprofile/edit"
              className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-xl bg-white/15 px-3 py-2 text-sm font-semibold text-white transition hover:bg-white/25"
            >
              <Pencil className="h-3.5 w-3.5" />
              Edit Profile
            </Link>
          </div>
        </div>

        <div className="px-4 py-4 sm:px-6">
          <div className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
            Your Preferences
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {prefs.map(([label, value]) => (
              <div key={label} className="rounded-xl bg-gray-50 px-3 py-2">
                <div className="text-[11px] text-gray-500">{label}</div>
                <div className="text-sm font-medium text-gray-900 truncate">{displayValue(value)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default ProfileCard;
